import { EditableValueList } from 'core/ui/controls/EditableValueList';
import { Message } from '../modal';

export class LegacyEditableValueList<T> extends EditableValueList<T> {

	override async confirm(message: string, action: () => void): Promise<void> {
		const result = await Message.confirm(message);
		if (result.ok)
			action();
	}
}